import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Packages = () => {
    const { t, i18n } = useTranslation();
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPackages();
    }, []);

    const fetchPackages = async () => {
        try {
            const response = await axios.get('https://hasanhaji.com/api/packages');
            setPackages(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching packages:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="packages-section">
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="packages-section">
            <div className="container">
                <h2 className="section-title">{t('packages.title')}</h2>
                <p className="text-center mb-5 text-muted">{t('packages.subtitle')}</p>

                <div className="row g-4">
                    {packages.map((pkg) => (
                        <div key={pkg.id} className="col-lg-4 col-md-6">
                            <div className="package-card">
                                <div className="package-header">
                                    <h3 className="package-name">
                                        {i18n.language === 'ar' ? pkg.nameAr : pkg.nameEn}
                                    </h3>
                                    <div className="package-price">
                                        <span className="price-amount">{pkg.price}</span>
                                        <span className="price-currency">{t('packages.currency')}</span>
                                    </div>
                                </div>

                                {(() => {
                                    const desc = i18n.language === 'ar' ? pkg.descriptionAr : pkg.descriptionEn;
                                    return desc && desc.trim() !== "";
                                })() && (
                                        <div className="package-description">
                                            <p>{i18n.language === 'ar' ? pkg.descriptionAr : pkg.descriptionEn}</p>
                                        </div>
                                    )}


                                <div className="package-features">
                                    <h4 className="features-title">{t('packages.includes')}</h4>
                                    <ul className="features-list">
                                        {pkg.features && pkg.features.map((feature, index) => (
                                            <li key={index} className="feature-item">
                                                <i className="fas fa-check-circle"></i>
                                                <span>{i18n.language === 'ar' ? feature.nameAr : feature.nameEn}</span>
                                                {feature.count && <span className="feature-count">({feature.count})</span>}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="package-footer">
                                    <button className="btn-package">
                                        {t('packages.bookNow')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Packages;
